import { styled } from "@mui/material"

export const StyledIcon = styled("img")(
  ({ size }: { size: number | string }) => ({
    borderRadius: "40%",
    width: size,
    height: size,
  }),
)
